export const TOKEN_ERROR = 'Not authenticated'
